import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import EcommerceHero from './components/EcommerceHero';
import EcommercePainPoints from './components/EcommercePainPoints';
import EcommerceHowHelps from './components/EcommerceHowHelps';
import EcommerceExamples from './components/EcommerceExamples';
import EcommerceHowItWorks from './components/EcommerceHowItWorks';
import EcommerceBenefits from './components/EcommerceBenefits';
import EcommerceFAQ from './components/EcommerceFAQ';
import EcommerceCTA from './components/EcommerceCTA';

export default function EcommercePage() {
  return (
    <>
      <title>AI Ads for Ecommerce | Get More Sales with Ecommerce Advertising | AdForge</title>
      <meta
        name="description"
        content="AI ads for ecommerce that actually drive sales. AdForge creates Facebook ads for ecommerce, Google Shopping ads, and Instagram ads in minutes. No marketing experience needed. Try free."
      />
      <meta
        name="keywords"
        content="AI ads for ecommerce, ecommerce advertising, facebook ads for ecommerce, google ads for ecommerce, online store advertising, ecommerce ad generator"
      />
      <link rel="canonical" href="https://adforge.ai/ai-ads-for-ecommerce" />
      <meta name="Last-modified" content={new Date().toISOString().split('T')[0]} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content="AI Ads for Ecommerce | AdForge — Get More Sales" />
      <meta
        property="og:description"
        content="AI-powered ecommerce advertising that drives real sales. Build Facebook ads, Google Shopping ads, and more in minutes. No experience needed."
      />
      <meta property="og:url" content="https://adforge.ai/ai-ads-for-ecommerce" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="AI Ads for Ecommerce | AdForge" />
      <meta
        name="twitter:description"
        content="Stop wasting money on ads that don't convert. AdForge builds AI ads for ecommerce in minutes. Free to start."
      />

      <script type="application/ld+json">{JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'AI Ads for Ecommerce — AdForge',
        description:
          'AdForge creates AI ads for ecommerce stores including fashion, home goods, health products, beauty, and more. Generate Facebook ads and Google Shopping ads in minutes.',
        url: 'https://adforge.ai/ai-ads-for-ecommerce',
        mainEntity: {
          '@type': 'SoftwareApplication',
          name: 'AdForge AI Ad Generator for Ecommerce',
          applicationCategory: 'BusinessApplication',
          operatingSystem: 'Web',
          offers: {
            '@type': 'Offer',
            price: '0',
            priceCurrency: 'USD',
            description: 'Free plan available — no credit card required',
          },
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: '4.9',
            reviewCount: '3140',
          },
        },
      })}</script>

      <script type="application/ld+json">{JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'Do I need marketing experience to use AI ads for ecommerce?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'No. AdForge is built for store owners with zero marketing experience. You answer a few simple questions about your product and the AI does the rest — writing the copy, generating images, and formatting ads for Facebook, Instagram, and Google.',
            },
          },
          {
            '@type': 'Question',
            name: 'How much does ecommerce advertising with AdForge cost?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'AdForge is free to start. Paid plans start at $29/month. Your actual Facebook or Google ad spend is separate and set by you directly in the ad platform.',
            },
          },
          {
            '@type': 'Question',
            name: 'What types of ecommerce stores can use AdForge?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'AdForge works for virtually any ecommerce store: fashion, home goods, health and wellness, beauty, electronics, pet products, sports gear, food and beverage, and more.',
            },
          },
          {
            '@type': 'Question',
            name: 'How fast can I create ecommerce ads with AdForge?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Most store owners generate their first complete ad package — including copy, headlines, hooks, and AI images — in under 3 minutes.',
            },
          },
          {
            '@type': 'Question',
            name: 'Does AdForge create Google Shopping ads for ecommerce too?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Yes. AdForge generates ad copy optimized for Facebook, Instagram, Google Ads, TikTok, and LinkedIn. You get platform-specific formatting for each.',
            },
          },
        ],
      })}</script>

      <div className="min-h-screen bg-white">
        <Navbar />
        <main>
          <EcommerceHero />
          <EcommercePainPoints />
          <EcommerceHowHelps />
          <EcommerceExamples />
          <EcommerceHowItWorks />
          <EcommerceBenefits />
          <EcommerceFAQ />
          <EcommerceCTA />
        </main>
        <Footer />
      </div>
    </>
  );
}
